import { EnhancementOption } from '../EnhancementOption/EnhancementOption'
import { FontRole } from 'types'
import { FontItem } from '../FontItem/FontItem'
import Styles from './FontOption.module.scss'
import { FontWeightType } from 'components/VisualStudioPlayground/VisualEditor/Types'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { Edit1 } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  titleFontFamily: string
  bodyFontFamily: string
  titleFontWeight?: FontWeightType
  bodyFontWeight?: FontWeightType
  titleFontStyle?: string
  bodyFontStyle?: string
  description?: string[]
  isSelected: boolean
  onSelect: () => void
  ordinal: number
  title: string
  badgeText?: string
  onFontChange: (role: FontRole, family: string, weights: FontWeightType[], style: string) => void
  isFromWebsite?: boolean
}

export const FontOption = ({
  titleFontFamily,
  bodyFontFamily,
  titleFontWeight,
  bodyFontWeight,
  titleFontStyle,
  bodyFontStyle,
  description,
  isSelected,
  onSelect,
  ordinal,
  title,
  badgeText,
  onFontChange,
  isFromWebsite,
}: Props) => (
  <EnhancementOption
    isSelected={isSelected}
    onSelect={onSelect}
    ordinal={ordinal}
    title={title}
    badgeText={badgeText}
    description={description}
    isFromWebsite={isFromWebsite}
  >
    <div className={Styles.fontOptions}>
      <FontItem
        role={FontRole.Title}
        fontFamily={titleFontFamily}
        fontWeight={titleFontWeight}
        fontStyle={titleFontStyle}
        onChange={onFontChange}
      />
      <FontItem
        role={FontRole.Body}
        fontFamily={bodyFontFamily}
        fontWeight={bodyFontWeight}
        fontStyle={bodyFontStyle}
        onChange={onFontChange}
      />
    </div>
    <ResponsiveDesign.Mobile>
      <div className={Styles.mobileEducation}>
        <Edit1 color="var(--dark-60)" />
        <Text variant="secondary" color="var(--dark-60)">
          Tap font to edit
        </Text>
      </div>
    </ResponsiveDesign.Mobile>
  </EnhancementOption>
)
